import { render } from "./ModalVisualizarPapeis.vue?vue&type=template&id=03a4686e&scoped=true"
import script from "./ModalVisualizarPapeis.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarPapeis.vue?vue&type=script&lang=js"

import "./ModalVisualizarPapeis.vue?vue&type=style&index=0&id=03a4686e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a4686e"]])

export default __exports__